var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('check-authorization',{attrs:{"requiresAuthorizations":['crear roles'],"overrideIf":_vm.$store.getters['roleModule/isEditingRole']}},[(false)?_c('role-form'):_vm._e()],1),_c('check-authorization',{attrs:{"requiresAuthorizations":['listar roles', 'listar permisos']}},[_c('role-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }